import { useEffect, useState } from 'react';

export const PopupModal = ({ message }) => {
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 9999
        }}>
            <div style={{
                backgroundColor: 'white', padding: '30px', borderRadius: '10px',
                maxWidth: '500px', textAlign: 'center', boxShadow: '0 2px 20px rgba(0,0,0,0.2)'
            }}>
                <h2>Unsupported Browser</h2>
                <p>{message}</p>
            </div>
        </div>
    );
};

const useBrowserCheck = () => {
    const [unsupportedBrowser, setUnsupportedBrowser] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent;

        const isChrome = /Chrome/.test(userAgent) && !/Edg/.test(userAgent) && !/OPR/.test(userAgent);
        const isEdge = /Edg/.test(userAgent);
        const isFirefox = /Firefox/.test(userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

        const checkBrave = async () => {
            const isBrave = navigator.brave && (await navigator.brave.isBrave());

            if (
                isBrave ||
                (!isChrome && !isSafari && !isFirefox && !isEdge) ||
                (isChrome && navigator.brave)
            ) {
                setUnsupportedBrowser(true);
            }
        };

        checkBrave();
    }, []);

    return unsupportedBrowser;
};

export default useBrowserCheck;